import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import styled from 'styled-components';
import { createStyleFunction, getPropFilter, getPropNamesFromPropDefinition } from 'utils/ui/styleProps';
import { displayPropsDef } from 'styles/styleProps/displayProps';
import { sizePropsDef } from 'styles/styleProps/sizeProps';
import { marginPropsDef } from 'styles/styleProps/marginProps';
import { paddingPropsDef } from 'styles/styleProps/paddingProps';
import { themePropsDef } from 'styles/styleProps/themeProps';
import textProps, { textPropsDef } from 'styles/styleProps/textProps';
var propDefs = [].concat(_toConsumableArray(displayPropsDef), _toConsumableArray(sizePropsDef), _toConsumableArray(marginPropsDef), _toConsumableArray(paddingPropsDef), _toConsumableArray(themePropsDef));
var styleProps = createStyleFunction(propDefs);
var shouldForwardProp = getPropFilter([].concat(_toConsumableArray(getPropNamesFromPropDefinition([].concat(_toConsumableArray(propDefs), _toConsumableArray(textPropsDef)))), ['align', 'size']));
var Text = styled.span.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Text",
  componentId: "sc-1h8k31-0"
})(["", " ", ""], function (props) {
  return textProps(_objectSpread(_objectSpread({}, props), {}, {
    textAlign: props.align || props.textAlign,
    fontSize: props.size || props.fontSize
  }));
}, styleProps);
export default Text;